export const STATICDOCS_ANNOTATION = 'doctype';

export const ERROR_MESSAGE = {
  status: '404',
  statusMessage: 'File not found or an error occurred',
  additionalInfo:
    'The requested Documentation site could not be found or failed to load. Before packaging the documentation, verify that the site functions independently by opening the index.html file locally in a browser. This ensures all dependencies are correctly linked and the site structure is intact.',
  supportUrl: '/docs/default/Component/xelerate',
};
